export {};

declare global {
  interface Number {
    toMoney(): string;
  }
}

Number.prototype.toMoney = function (): string {
  try {
    if (typeof this !== "number") return "NaN";
    const toCurrency = this?.toLocaleString("en-US", {});
    return `${toCurrency || 0} Rwf`;
  } catch (error) {
    return `NaN`;
  }
};
